module.exports = __webpack_public_path__ + "img/Rank_01.3add9321.png";